import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_PROMO} from "../../utils/input-field-list-static-page";
import React, {useEffect} from "react";
import InputComponent from "../../components/input.component";
import {setPromoDetail, setPromoErrorMessage} from "../../reducers/promo.reducer";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {LoadingSvg} from "../../utils/image";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";

const PromoPage = () => {
    const dispatch = useDispatch()
    const {promoDetail, promoErrorMessage} = useSelector(state => state.promoReducer)
    const {fetching: getProductList} = useFetch(API.PAGE_GET_PRODUCT_LIST)
    const {fetching: getPromo} = useFetch(API.PROMO_GET_PROMO)
    const {fetching: updatePromo, isLoading} = useFetch(API.PROMO_UPDATE_PROMO)
    let fieldList = FIELD_LIST_PROMO

    const onChangeInput = (key, value, id) => {
        if(key === 'select_product'){
            let deleteList = promoDetail?.delete_product || []
            dispatch(setPromoDetail({[key]: value, delete_product: [...deleteList, id]}))
        } else {
            dispatch(setPromoDetail({[key]: value}))
        }
    }

    const onChangeProduct = (key, value) => {
        let deleteList = promoDetail?.delete_product?.filter(item => item !== value?.id)
        let currentProduct = promoDetail.select_product
        dispatch(setPromoDetail({[key]: currentProduct.concat(value), delete_product: deleteList || []}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const requestBody = {
            ...promoDetail,
            select_product: promoDetail.select_product.map(item => item.id) ?? []
        }
        updatePromo(requestBody).then(response => {
            dispatch(setPromoErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Promo Updated'))
            dispatch(setPromoDetail({...response?.data, delete_product: []}))
        }).catch(err => {
            dispatch(setPromoErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        Promise.all([getPromo(), getProductList()]).then(response => {
            dispatch(setPromoDetail({...response[0].data, delete_product: []}))
            fieldList[3].dataList = response[1].data
        }).catch(() => {
            dispatch(setToolsAlertMessage('Something Wrong!'))
        })

        return () => {
            dispatch(setPromoErrorMessage({}))
        }
    }, [])

    return (
        <div className={"col px-10"}>
            <form className={"space-y-4"}>
                <div className={"grid grid-cols-2 gap-x-16 gap-y-4"}>
                    {fieldList.map((item, index) => (
                        <div key={index} className={item.key === 'select_product' || item.key === 'title_promo'  ? 'col-span-2' : ''}>
                            <InputComponent key={index} item={item} data={promoDetail[item.key]} onChange={onChangeInput} onChangeInput={onChangeInput} onChangeProduct={onChangeProduct} error={promoErrorMessage}/>
                        </div>
                    ))}
                </div>
                <div className={"row font-semibold justify-center py-8"}>
                    <button onClick={(e) => onSubmitHandler(e)}
                            className={"w-60 py-2 bg-battleship-green hover:bg-gradient-to-b from-battleship-green to-monstera text-white rounded-lg"}>
                        {isLoading ? <img src={LoadingSvg} className={"w-5 mx-auto"}/> : 'Save All Changes'}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default PromoPage
